<template>
  <div class="flex flex-col text-left">
    <div class="relative">
      <select
        id="language-select"
        class="mt-1 w-full min-w-[150px] appearance-none rounded-xl border border-slate-200 bg-white px-3 py-2 pr-10 text-sm font-medium text-slate-700 shadow-sm transition focus:outline-none focus:ring-2 focus:ring-primary-100 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-300"
        :class="selectClass"
        v-model="selectedLanguage"
      >
        <option v-for="language in languages" :key="language.code" :value="language.code">
          {{ language.label }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-3 flex items-center"
        :class="chevronClass"
      >
        <ChevronDownIcon class="h-3 w-3" aria-hidden="true" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';
import { ChevronDownIcon } from '@heroicons/vue/24/outline';

withDefaults(
  defineProps<{
    selectClass?: string;
    chevronClass?: string;
  }>(),
  {
    selectClass: 'hover:border-primary-500 focus:border-primary-500',
    chevronClass: 'text-slate-400',
  },
);

const { locale } = useI18n();
const router = useRouter();
const route = useRoute();

const languages = [
  { code: 'de', label: 'Deutsch' },
  { code: 'en', label: 'English' },
];

const selectedLanguage = computed({
  get: () => locale.value,
  set: (newLocale: string) => changeLanguage(newLocale),
});

function changeLanguage(newLocale: string) {
  if (newLocale === locale.value) return;

  locale.value = newLocale;

  const currentPath = route.path;
  const segments = currentPath.split('/').filter(Boolean);

  if (segments.length > 0) {
    segments[0] = newLocale;
    const newPath = '/' + segments.join('/');
    void router.push({ path: newPath, query: route.query });
  } else {
    void router.push({ path: `/${newLocale}`, query: route.query });
  }
}
</script>
